export default __webpack_public_path__ + "static/media/Shore-S.4188e1b7.png";